import { render } from "./FormMic.vue?vue&type=template&id=2015c9c3&scoped=true"
import script from "./FormMic.vue?vue&type=script&lang=js"
export * from "./FormMic.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./FormMic.vue?vue&type=style&index=1&id=2015c9c3&lang=scss&scoped=true"

import exportComponent from "C:\\wamp2022\\www\\emotivapp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2015c9c3"]])

export default __exports__